import React, { createContext, useContext, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      setLoading(false);
      return;
    }

    const email = localStorage.getItem("userEmail") || "Demo User";
    const id = localStorage.getItem("userId");
    const api_key = localStorage.getItem("api_key");
    const first_name = localStorage.getItem("first_name") || "";
    const last_name = localStorage.getItem("last_name") || "";

    setUser({
      email,
      ...(id != null && id !== "" ? { id } : {}),
      ...(api_key ? { api_key } : {}),
      ...(first_name ? { first_name } : {}),
      ...(last_name ? { last_name } : {}),
    });
    setLoading(false);
  }, []);

  const login = (userData, token) => {
    localStorage.setItem("token", token);
    localStorage.setItem("userEmail", userData.email);

    if (userData.api_key != null && userData.api_key !== "") {
      localStorage.setItem("api_key", userData.api_key);
    } else {
      localStorage.removeItem("api_key");
    }

    if (userData.id != null && userData.id !== "") {
      localStorage.setItem("userId", String(userData.id));
      localStorage.setItem("user_id", String(userData.id));
    } else {
      localStorage.removeItem("userId");
      localStorage.removeItem("user_id");
    }

    if (userData.first_name) {
      localStorage.setItem("first_name", userData.first_name);
    } else {
      localStorage.removeItem("first_name");
    }

    if (userData.last_name) {
      localStorage.setItem("last_name", userData.last_name);
    } else {
      localStorage.removeItem("last_name");
    }

    setUser(userData);
    console.log("[Productive] Login success — session saved", {
      email: userData.email,
      userId: localStorage.getItem("user_id") || localStorage.getItem("userId"),
      hasAgentIntegrations: Boolean(localStorage.getItem("agent_integrations")),
      features: { brainstorming: true, buildTag: "brainstorm-v1" },
    });
    navigate("/");
  };

  const logout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("userEmail");
    localStorage.removeItem("api_key");
    localStorage.removeItem("userId");
    localStorage.removeItem("user_id");
    localStorage.removeItem("agent_integrations");
    localStorage.removeItem("first_name");
    localStorage.removeItem("last_name");
    setUser(null);
    navigate("/login");
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <AuthContext.Provider value={{ user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};
